import './TemplateCreatedByUserBadge.scss'
import React, { PropsWithChildren } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { User } from '../../../models/User'
import UserWithAvatar from '../../../apps/professional-app/fa/common/user/UserWithAvatar'
import { getUserDisplayName } from '../../../apps/professional-app/fa/common/aifeatures/utils'
import { ReactComponent as ZocksIcon } from '../../../assets/ZocksIcon.svg'

export interface TemplateCreatedByUserBadgeProps {
  createdByUser: User
}

export const TemplateCreatedByUserBadge: React.FC<TemplateCreatedByUserBadgeProps> = ({ createdByUser }) => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)

  const getUserNameElement = (user: User): React.FC<PropsWithChildren> | null => {
    const { id } = user
    if (id === currentUserId) {
      return ({ children }) => <span className='user-name'>{children} (You)</span>
    }
    return null
  }

  return <UserWithAvatar name={getUserDisplayName(createdByUser)} nameElement={getUserNameElement(createdByUser)} />
}

export const SystemUserBadge = () => {
  return (
    <div className='user-avatar'>
      <ZocksIcon className='system-user-img' />
      <span className='user-name'>Zocks</span>
    </div>
  )
}
